<script lang="ts">
    import type { Readable } from "svelte/store";

    export let checked: Readable<boolean>;
</script>

<!----------------------------------------------------------------------------->

<input type="checkbox" bind:checked={$checked} />

<!----------------------------------------------------------------------------->

<style>
    input {
        margin-left: -0.5em;
        margin-right: 0.5em;
    }
</style>
